import { ROUTES } from '../../../routes/consts';
import { Button } from '@platform/components';

export const ChallengeFormBackground = ({
  onSubmit,
  backgroundImage,
  children,
}: {
  onSubmit: () => void;
  backgroundImage: string;
  children: React.ReactNode;
}) => {
  return (
    <form
      className='w-full h-[100vh] md:max-h-[100vh] flex flex-col overflow-y-auto md:overflow-y-auto'
      onSubmit={onSubmit}
    >
      <div className='w-full flex flex-row h-full md:h-[100vh]'>
        <div className='hidden h-full md:block w-1/2 bg-gray-50'>
          <div
            className='hidden h-full w-full md:flex justify-start items-start'
            style={{
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundColor: 'white',
            }}
          />
        </div>
        <div className='w-full h-full md:w-1/2 md:px-8 md:py-4 flex justify-center overflow-y-scroll '>
          {children}
        </div>
      </div>
      <ChallengesFooter />
    </form>
  );
};

const ChallengesFooter = () => {
  return (
    <div className='flex justify-end w-full bg-gray-50 py-6 px-4 md:px-8 min-h-[88px] h-[88px]'>
      <div className='hidden md:flex flex-row gap-4 justify-between'>
        <Button
          variant='secondary-gray'
          additionalClassnames='w-[75px]'
          size='md'
          href={`/platform${ROUTES.DASHBOARD}`}
        >
          Cancel
        </Button>
        <Button variant='primary' size='md' type='submit' additionalClassnames='w-[107px]'>
          Submit
        </Button>
      </div>
      <div className='flex md:hidden flex-row gap-4 justify-between w-full'>
        <Button
          variant='secondary-gray'
          size='md'
          href={`/platform${ROUTES.DASHBOARD}`}
          additionalClassnames='w-1/2'
        >
          Cancel
        </Button>
        <Button variant='primary' size='md' type='submit' additionalClassnames='w-1/2'>
          Submit
        </Button>
      </div>
    </div>
  );
};
